export const securedPath = [
  '/appointments/:serviceName/about-you',
  '/appointments/:serviceName/review',
  '/appointments/:serviceName/bookings',
  '/appointments/manage-appointments',
];
